var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftArrowBlue = function SvgLeftArrowBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.42 2.177.688-.725L3.732 0l-.688.726L.688 3.212 0 3.938l.086.09-.008.01.688.726L3.122 7.25l.688.725 1.376-1.451-.688-.726-1.755-1.851 1.677-1.77Z",
    fill: "#011D6B"
  })));
};
export default SvgLeftArrowBlue;